
import { useContext } from 'react';
import useAxiosCall from './useAxiosCall';
import { useNotification } from '../Context/NotificationContext';
import { useSidebarPermission } from '../Context/SidebarPermissionContext';
import { UserContext } from '../Context/UserContext';

const useLogout = () => {
  const { makeApiCall } = useAxiosCall();
  const { signOut } = useContext(UserContext);
  const { notifications, setNotifications, notificationsFetch, setNotificationsFetch, notificationsCount, setNotificationsCount} = useNotification();
  const { clearPermissions } = useSidebarPermission();

  const clearSessionAndGoLogin = () => {
    signOut();
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    window.location.assign(`${base}/login`);
  };

  const handleApiCallSuccess = () => {
    clearSessionAndGoLogin();
  };

  const handleApiCallError = (errorMessage) => {
    console.error('Error during logout:', errorMessage);
  };

  const handleLogout = async () => {
    setNotifications([]);
    setNotificationsCount(0);
    clearPermissions();
    window.echo.leaveAllChannels();
    try {
      await makeApiCall({
        onSuccess: handleApiCallSuccess,
        onError: handleApiCallError,
        requestType: 'POST',
        url: 'logout',
      });

    } catch (error) {
      console.error('API call error:', error);
    }
  };

  return { handleLogout };
};

export default useLogout;
